import {Collapse, Row} from 'antd'
import _ from 'lodash'
import {useAppConfig} from 'modules/local'
import React, {useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {getLogin} from 'redux/selectors'
import renderCategoryLink from 'views/LandingPage/functions/renderCategoryLink'
import {compare, NullAsDefault} from 'views/Shared'
import useTranslate from '../../modules/local/useTranslate'
import {DelayRender} from '../Discovery/DelayRender'
import AllCategoriesFilter from './components/AllCategoriesFilter'
import './index.css'
import {BsCaretDownFill, BsCaretRightFill} from "react-icons/bs";

const CategoryGroupBy = Object.freeze({
    NONE: 'none',
    FIRST_LETTER: 'first-letter',
})

export const CategoryFilterGroup = ({
                                        title,
                                        categories = [],
                                        renderCategory = renderCategoryLink,
                                    }) => {
    const t = useTranslate()
    return (
        <Collapse
            defaultActiveKey={[0]}
            expandIconPosition="right"
            expandIcon={({isActive}) => (
                isActive ? <BsCaretDownFill className="text-color-100" /> : <BsCaretRightFill className="text-color-100" />
            )}
            className="read-only-content w-full rounded-lg custom-collapse-category">
            <Collapse.Panel
                header={
                    <div className="font-extrabold text-xl text-primary-500 leading-tight">{t(title)}</div>
                }>
                <div className="flex flex-wrap gap-3 p-2">
                    {categories.map(renderCategory)}
                </div>
            </Collapse.Panel>
        </Collapse>
    )
}

const Category = ({
                      toggle = NullAsDefault,
                      renderCategory,
                      groupBy = CategoryGroupBy.FIRST_LETTER,
                  }) => {
    const t = useTranslate()
    const login = useSelector(getLogin)

    const [values, setValues] = useState({
        keyword: '',
        following: false,
    })

    const appConfig = useAppConfig()

    const {categories = []} = appConfig

    const selectedCategories = _.get(login, 'categories', []).reduce(
        (result, value) => {
            result[value.id] = true
            return result
        },
        {}
    )

    const content = useMemo(() => {
        const current = categories.filter(
            ({id}) => !!!values.following || !!selectedCategories[id]
        )
        const result = current.filter(({name}) => {
            return compare(name, values.keyword)
        })
        switch (groupBy) {
            case CategoryGroupBy.FIRST_LETTER:
                const groups = _.groupBy(result, ({name}) => name.charAt(0))
                return Object.keys(groups).map((name, index) => {
                    const items = _.get(groups, name, [])
                    return (
                        <CategoryFilterGroup
                            key={index}
                            title={name}
                            categories={items}
                            renderCategory={renderCategory}
                        />
                    )
                })
            case CategoryGroupBy.NONE:
            default:
                return () => result.map(renderCategoryLink)
        }
    }, [categories, values, groupBy])

    return (
        <div className="background max-w-5xl mx-auto w-full relative pb-8">
            <h2 className="p-2 w-full text-2xl font-bold">{t('category')}</h2>
            <AllCategoriesFilter
                onChange={(event) => {
                    const target = event.target
                    setValues({
                        ...values,
                        [target.name]: target.value,
                    })
                }}
                callback={toggle}
                following={values.following}
                selectedCategories={selectedCategories}
                className="p-2 flex flex-wrap items-end justify-end"
            />

            <Row
                wrap
                gutter={[0, 8]}
                className="p-2">
                <DelayRender>{content}</DelayRender>
            </Row>
        </div>
    )
}

export default Category
